export default function IRQBadge({isActive, color="#e8c875"}) {
  return(
    <div style={{width:18,height:18,borderRadius:"50%",background:isActive?`${color}28`:"rgba(255,255,255,0.07)",border:`1px solid ${isActive?color+"80":"rgba(255,255,255,0.18)"}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,color:isActive?color:"rgba(255,255,255,0.45)",fontWeight:800,flexShrink:0,transition:"all .15s"}}>
      {isActive?"▲":"?"}
    </div>
  );
}
